import { createTheme } from '@mui/material/styles';

const ThemeCustomization = () => {

    let theme = createTheme();

    theme = createTheme({
        palette: {
            primary: {
                main: "#0089d1"
            },
            secondary: {
                main: "#a7cd3a"
            }
        }
    });

    return theme;
}

export default ThemeCustomization;